module.exports = __webpack_public_path__ + "static/media/hernandez_barreda.90c28f4c.jpg";